export default __webpack_public_path__ + "static/media/user1.2500e80e.jpg";